import React, { useEffect, useRef, useState } from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

type TimerProps = {
    time: Date | null;
};

const Timer: React.FC<TimerProps> = ({ time }) => {
    const textColor = useColorModeValue("navy.700", "white");

    const timerRef = useRef(0);
    const [, setRenderTrigger] = useState(0);

    useEffect(() => {
        if (time === null) return;
        const initialDifference = Math.floor((Date.now() - new Date(time).getTime()) / 1000);
        timerRef.current = initialDifference;
        const interval = setInterval(() => {
            timerRef.current += 1;
            setRenderTrigger((prev) => prev + 1);
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [time]);

    if (time === null) {
        return (
            <Box color={textColor} fontSize="xl" fontWeight="bold">
                <span>0</span> : <span>00</span> : <span>00</span>
            </Box>
        );
    }
    const hours = Math.floor((timerRef.current / (60 * 60)) % 24);
    const minutes = Math.floor((timerRef.current / 60) % 60);
    const seconds = timerRef.current % 60;

    return (
        <Box color={textColor} fontSize="xl" fontWeight="bold">
            <span>{hours}</span> :{" "}
            <span>{minutes < 10 ? "0" + minutes : minutes}</span> :{" "}
            <span>{seconds < 10 ? "0" + seconds : seconds}</span>
        </Box>
    );
};

export default Timer;
